document.addEventListener("DOMContentLoaded", function () {

    const parent_variant = document.querySelector('.variant-picker__form')
    if(!parent_variant){
        return console.log('Cant find parent variant DOM element')
    }

    parent_variant.addEventListener('click', (e)=>{

        if(e.target.tagName !== 'INPUT'){
            return console.log('Element is not variant')
        }

        
        //console.log('is variant ', e.target )

        const { value } = e.target
        //console.log(Number(value))
        
        
        // todo: first render

        const stock_element = document.querySelector('[data-js-stock-variant]')
        const base_qty = 100
        if(!stock_element){
            return console.log('Cant find stock element')
        }
        stock_element.innerText = base_qty / Number(value)

    })


})